import { formatThousandAndUnit, keepOneOrLine, keepPercentOneNull, keepWithNumberOrNull } from '@/utils/utils';
import { V2EnergyOverviewCostPostResponse } from '@maxtropy/device-customer-apis-v2';
import circleImg from '../../../../../../imgs/usage_spin_circle.png';
import { formatName, getEnergyMediumColor } from '@/pages/WgqAllMaps/utils';

export const getChartOption = (
  energyCostData?: V2EnergyOverviewCostPostResponse,
  energyMediumColorMap?: Record<string, string>
) => {
  return {
    color:
      energyCostData?.costFrom?.map((item, index) =>
        getEnergyMediumColor({
          energyMediumId: item.energyMediumId,
          energyMediumName: item.energyMediumName,
          colorMap: energyMediumColorMap,
          fallbackIndex: index,
        })
      ) ?? [],
    legend: {
      show: false,
    },
    tooltip: {
      confine: true,
      formatter: (param: any) => {
        const moneyUnit = formatThousandAndUnit(param.data?.value);
        return `
          <div style="width:max-content;">
            <div style="display:flex;gap: 12px;align-items:center;">
            <span style="display:inline-block;margin-right: -10px">${param.marker}</span><span>${
          param.name
        }</span><span>${keepOneOrLine(param.data.percent)}%</span><span>${moneyUnit.value}${
          moneyUnit.unit
        }元</span></div>
          </div>
        `;
      },
    },

    graphic: {
      elements: [
        {
          type: 'image',
          left: 'center',
          top: 'center',
          style: {
            image: circleImg,
            x: -28,
            y: -28,
            width: 56,
            height: 56,
          },
          keyframeAnimation: [
            {
              // 动画时长，单位 ms
              duration: 80000,
              // 设置旋转动画是否循环
              loop: true,
              easing: 'linear',
              // 动画的关键帧
              keyframes: [
                {
                  // percent为关键帧的位置,0为第一个,1为最后一个
                  percent: 0,
                  rotation: 0,
                  transition: ['rotation'],
                },
                {
                  percent: 1,
                  rotation: 360,
                  transition: ['rotation'],
                },
              ],
            },
          ],
        },
      ],
    },
    series: [
      {
        type: 'pie',
        radius: ['35%', '90%'],
        center: ['50%', '50%'],
        padAngle: 4,
        itemStyle: {
          borderRadius: 8,
        },
        avoidLabelOverlap: false,
        data:
          energyCostData?.costFrom?.map(item => ({
            name: formatName(item.energyMediumName),
            value: keepWithNumberOrNull(item.charges),
            percent: keepPercentOneNull(item.percentage),
          })) || [],
        showEmptyCircle: false,
        minAngle: 4,
        label: {
          show: false,
        },
      },
    ],
  };
};
